import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_TICKETFEEDBACK } from "../../../utils/constants";
import { TicketFeedbackInterface } from "../../../models/TicketModule/TicketFeedback";
import ticketFeedbackService from "../../../services/ticketService/feedbackService";

const useFeedback = (ticketId: string) =>
  useQuery<TicketFeedbackInterface[], Error>({
    queryKey: [CACHE_KEY_TICKETFEEDBACK, ticketId],
    queryFn: () => ticketFeedbackService.Get(ticketId),
    enabled: !!ticketId,
  });

export default useFeedback;
